import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import ExportFile from '../exportFile';
import { IPSService } from '@/services/ipsServices';
import { moneyRevert, parseSec } from '@/util';

export enum SORT_TYPE {
    PV, // 0PV倒叙 
    PV_ASC, // 1PV正序
    UV, // 2UV倒叙
    UV_ASC, // 3UV正序
    NEW, // 4新用户倒序
    NEW_ASC, // 5新用户正序
    STAY_TIME, // 6人均停留时间倒序
    STAY_TIME_ASC, // 7人均停留时间正序
    ORDER_NUM, //  8订单数倒序
    ORDER_NUM_ASC, // 9订单数正序 
    ORDER_MONEY, // 10订单额倒序
    ORDER_MONEY_ASC, // 11订单额正序
    RETURN_NUM, // 12退单数倒序
    RETURN_NUM_ASC, // 13退单数正序
    RETURN_MONEY, // 14退单额倒序
    RETURN_MONEY_ASC, // 15退单额正序
    ORDER_DISCOUNT_RATE, // 16订单折扣率倒叙
    ORDER_DISCOUNT_RATE_ASC, // 17订单折扣率正序
}
@Component
export default class CloudMallMode extends Vue {
    loadingState = false
    dataList = []
    total = 0
    page = 1
    pageSize = 10
    sort = 0
    keywords = ''
    date: any = 0
    yesterday: any = 0
    dateTime: any = 0

    mounted() {
        this.dateTime = parseSec(7)
        this.date = +moment(this.dateTime).format('YYYYMMDD')
        this.yesterday = parseSec(7)
        this.getVisitList();
    }
    get exportParams() {
        const postParams = {
            exportType: 'wxDayVisitTrend',
            params: {
                date: this.date,
                operationModes: [2, 3],
                keywords: this.keywords,
                page: this.page,
                pageSize: this.pageSize,
                sort: this.sort
            },
        };
        return postParams;
    }
    getVisitList() {
        const postParams = {
            date: this.date,
            operationModes: [2, 3],
            keywords: this.keywords,
            page: this.page,
            pageSize: this.pageSize,
            sort: this.sort
        }
        this.loadingState = true;
        IPSService.siteGroupVisitList({ postParams }).then((res) => {
            this.loadingState = false;
            this.dataList = res.list;
            this.total = res.count;
        });
    }
    onDateChange() {
        this.date = +moment(this.dateTime).format('YYYYMMDD')
        this.getVisitList()
    }
    onSearch() {
        this.page = 1
        this.getVisitList()
    }
    /**
 * 切换页码
 * @param {number} val
 */
    onPageChange(val: number): void {
        this.page = val;
        this.getVisitList();
    }

    /**
     * 切换每页显示数量
     * @param {number} val
     */
    onPageSizeChange(val: number): void {
        this.page = 1;
        this.pageSize = val;
        this.getVisitList();
    }
    onSortChange(column) {
        switch (column.prop) {
            case 'visitPv':
                this.sort = column.order === 'ascending' ? SORT_TYPE.PV_ASC : SORT_TYPE.PV;
                break;
            case 'visitUv':
                this.sort = column.order === 'ascending' ? SORT_TYPE.UV_ASC : SORT_TYPE.UV;
                break;
            case 'visitUvNew':
                this.sort = column.order === 'ascending' ? SORT_TYPE.NEW_ASC : SORT_TYPE.NEW;
                break;
            case 'stayTimeUv':
                this.sort = column.order === 'ascending' ? SORT_TYPE.STAY_TIME_ASC : SORT_TYPE.STAY_TIME;
                break;
            case 'orderCount':
                this.sort = column.order === 'ascending' ? SORT_TYPE.ORDER_NUM_ASC : SORT_TYPE.ORDER_NUM;
                break;
            case 'orderPrice':
                this.sort = column.order === 'ascending' ? SORT_TYPE.ORDER_MONEY_ASC : SORT_TYPE.ORDER_MONEY;
                break;
            case 'returnCount':
                this.sort = column.order === 'ascending' ? SORT_TYPE.RETURN_NUM_ASC : SORT_TYPE.RETURN_NUM;
                break;
            case 'returnPrice':
                this.sort = column.order === 'ascending' ? SORT_TYPE.RETURN_MONEY_ASC : SORT_TYPE.RETURN_MONEY;
                break;
            case 'pert':
                this.sort = column.order === 'ascending' ? SORT_TYPE.ORDER_DISCOUNT_RATE_ASC : SORT_TYPE.ORDER_DISCOUNT_RATE;
                break;
            default:
                this.sort = SORT_TYPE.PV;
                break;
        }
        this.getVisitList();
    }
    render(h) {
        const self = this
        return (
            <div>
                <div class="filterController">
                    <div class="inputWrapper">
                        <el-input v-model={this.keywords} placeholder="小程序名称、云店名称"></el-input>
                        <i class="iconfont iconsousuo" onClick={() => this.onSearch()}></i>
                    </div>
                    <div class="inputWrapper r-ml-24">
                        <el-date-picker
                            v-model={this.dateTime}
                            type="date"
                            onChange={() => this.onDateChange()}
                            picker-options={{
                                disabledDate(time) {
                                    return time.getTime() > self.yesterday;
                                },
                            }}
                            placeholder="选择日期">
                        </el-date-picker>
                    </div>
                </div>
                <div class="tableWrapper">
                    <el-table data={this.dataList} v-loading={this.loadingState} height={this.$store.state.windowHeight - 281} class="width-100" tooltip-effect="light" on-sort-change={this.onSortChange.bind(this)}>
                        <el-table-column type="index" label="ID" width="55" align="center" />
                        <el-table-column prop="sgName" width="180" label="云店名称" show-overflow-tooltip />
                        <el-table-column prop="appName" label="小程序名称" show-overflow-tooltip />
                        <el-table-column prop="visitPv" label="PV" sortable show-overflow-tooltip align="right" />
                        <el-table-column prop="visitUv" label="UV" sortable show-overflow-tooltip align="right" />
                        <el-table-column prop="visitUvNew" label="新用户数" sortable show-overflow-tooltip align="right" />
                        <el-table-column prop="stayTimeUv" label="人均停留时长(s)" sortable show-overflow-tooltip align="right" />
                        <el-table-column prop="orderCount" label="订单数" sortable show-overflow-tooltip align="right" />
                        <el-table-column prop="orderPrice" label="订单额" sortable show-overflow-tooltip align="right"
                            {...{
                                scopedSlots: {
                                    default: (scope) => {
                                        return <div>{moneyRevert(scope.row.orderPrice)}</div>;
                                    },
                                },
                            }} />
                        <el-table-column prop="returnCount" label="退单数" sortable show-overflow-tooltip align="right" />
                        <el-table-column prop="returnPrice" label="退单额" sortable show-overflow-tooltip align="right"
                            {...{
                                scopedSlots: {
                                    default: (scope) => {
                                        return <div>{moneyRevert(scope.row.returnPrice)}</div>;
                                    },
                                },
                            }}
                        />
                        <el-table-column prop="pert" label="订单折扣率" sortable show-overflow-tooltip align="right" />
                    </el-table>
                </div>
                <div class="bottomWrapper">
                    <ExportFile export-text="下载为Excel" params={this.exportParams} is-button={true} service-url="adminExport" />
                    <el-pagination on-size-change={this.onPageSizeChange}
                        on-current-change={this.onPageChange}
                        current-page={this.page}
                        page-sizes={[10, 30, 60, 100]}
                        page-size={this.pageSize}
                        layout="total, sizes, prev, pager, next, jumper"
                        total={this.total} />
                </div>
            </div>
        );
    }
}